import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "m6.28 5.45-1.78-.9L5.76 2h8.47l1.27 2.55-1.78.89L13 4H7l-.72 1.45M16.62 8h-4.53l-.79-3H8.7l-.79 3H3.38L2.1 10.55l1.79.89.73-1.44h10.76l.72 1.45 1.79-.89L16.62 8m-.85 14H13.7l-.24-.9L10 15.9l-3.47 5.2-.23.9H4.23l2.89-11h2.07l-.36 1.35L10 14.1l1.16-1.75-.35-1.35h2.07l2.89 11M9.4 15l-.9-1.35-1.18 4.48L9.4 15m3.28 3.12-1.18-4.48-.9 1.36 2.08 3.12ZM21 13l2-7h-2V1l-2 7h2" }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "TransmissionTowerBolt"}) } }